import { FONT_FAMILIES } from './constants';

export const createTypography = () => ({
  fontFamily: FONT_FAMILIES.TEXT,
  h1: {
    fontFamily: FONT_FAMILIES.DISPLAY,
    fontWeight: 500,
    fontSize: '3.5rem',
    lineHeight: 1.2,
  },
  h2: {
    fontFamily: FONT_FAMILIES.DISPLAY,
    fontWeight: 500,
    fontSize: '3rem',
    lineHeight: 1.2,
  },
  h3: {
    fontFamily: FONT_FAMILIES.DISPLAY,
    fontWeight: 500,
    fontSize: '2.25rem',
    lineHeight: 1.3,
  },
  h4: {
    fontFamily: FONT_FAMILIES.DISPLAY,
    fontWeight: 500,
    fontSize: '1.75rem',
    lineHeight: 1.3,
  },
  h5: {
    fontFamily: FONT_FAMILIES.DISPLAY,
    fontWeight: 500,
    fontSize: '1.5rem',
    lineHeight: 1.4,
  },
  h6: {
    fontFamily: FONT_FAMILIES.DISPLAY,
    fontWeight: 500,
    fontSize: '1.25rem',
    lineHeight: 1.4,
  },
  body1: {
    fontFamily: FONT_FAMILIES.TEXT,
    fontWeight: 400,
    fontSize: '1rem',
    lineHeight: 1.5,
  },
  body2: {
    fontFamily: FONT_FAMILIES.TEXT,
    fontWeight: 400,
    fontSize: '0.875rem',
    lineHeight: 1.5,
  },
  caption: {
    fontFamily: FONT_FAMILIES.TEXT,
    fontWeight: 400,
    fontSize: '0.75rem',
    textTransform: 'uppercase',
    letterSpacing: '0.1em',
    lineHeight: 1.4,
  },
  button: {
    fontFamily: FONT_FAMILIES.TEXT,
    fontWeight: 500,
    textTransform: 'none',
    letterSpacing: '0.02em',
  },
  subtitle1: {
    fontFamily: FONT_FAMILIES.TEXT,
    fontWeight: 500,
    fontSize: '1rem',
    lineHeight: 1.5,
  },
  subtitle2: {
    fontFamily: FONT_FAMILIES.TEXT,
    fontWeight: 500,
    fontSize: '0.875rem',
    lineHeight: 1.5,
  },
  overline: {
    fontFamily: FONT_FAMILIES.TEXT,
    fontWeight: 500,
    fontSize: '0.75rem',
    textTransform: 'uppercase',
    letterSpacing: '0.15em',
    lineHeight: 1.4,
  }
}); 